import { create } from "zustand";

interface PreferenceState {
  lastSelectedIds: Record<string, any[]>;
  printMethod: 'network' | 'local';
  saveLastSelection: (moduleKey: string, id: any) => void;
  setPrintMethod: (method: 'network' | 'local') => void;
  getSortedList: <T extends { id: any }>(moduleKey: string, list: T[]) => T[];
}

export const usePreferenceStore = create<PreferenceState>((set, get) => ({
  lastSelectedIds: {},
  printMethod: (localStorage.getItem('preferredPrintMethod') as 'network' | 'local') || 'network',

  setPrintMethod: (method) => {
    localStorage.setItem('preferredPrintMethod', method);
    set({ printMethod: method });
  },

  saveLastSelection: (moduleKey, id) => {
    set((state) => {
      // Hafızada yoksa localStorage'dan çek, varsa hafızadakini kullan
      let currentIds: any[] = state.lastSelectedIds[moduleKey] || [];
      if (currentIds.length === 0) {
        try {
          currentIds = JSON.parse(localStorage.getItem(`last_sel_${moduleKey}`) || "[]");
        } catch {
          currentIds = [];
        }
      }

      const filtered = currentIds.filter((item) => item !== id);
      const newIds = [id, ...filtered].slice(0, 10);

      localStorage.setItem(`last_sel_${moduleKey}`, JSON.stringify(newIds));

      return {
        lastSelectedIds: {
          ...state.lastSelectedIds,
          [moduleKey]: newIds,
        },
      };
    });
  },

  getSortedList: (moduleKey, list) => {
    // 1. Önce Zustand state'ine bakıyoruz
    let currentIds = get().lastSelectedIds[moduleKey];
    
    // 2. State'te yoksa doğrudan localStorage'dan okuyoruz (set yapmadan!)
    if (!currentIds) {
      try {
        currentIds = JSON.parse(localStorage.getItem(`last_sel_${moduleKey}`) || "[]");
      } catch {
        currentIds = [];
      }
    }

    if (!currentIds || currentIds.length === 0) return list;

    return [...list].sort((a, b) => {
      const indexA = currentIds.indexOf(a.id);
      const indexB = currentIds.indexOf(b.id);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });
  },
}));